import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { formatTrialDate, MAX_TRIAL_DAYS, trialEndDate, validTrialDays } from "./trials";

interface TrialLengthFieldsProps {
  idPrefix: string;
  days: number;
  neverExpires: boolean;
  onChange: (patch: { days?: number; neverExpires?: boolean }) => void;
}

const TrialLengthFields = ({ idPrefix, days, neverExpires, onChange }: TrialLengthFieldsProps) => (
  <div className="space-y-3">
    <div className="flex items-center justify-between gap-3">
      <Label htmlFor={`${idPrefix}-never-expires`}>Never expires</Label>
      <Switch
        id={`${idPrefix}-never-expires`}
        checked={neverExpires}
        onCheckedChange={(checked) => onChange({ neverExpires: checked })}
      />
    </div>
    {!neverExpires && (
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-days`}>Trial length in days</Label>
        <Input
          id={`${idPrefix}-days`}
          type="number"
          inputMode="numeric"
          min={1}
          max={MAX_TRIAL_DAYS}
          value={Number.isNaN(days) ? "" : days}
          onChange={(event) => onChange({ days: event.target.valueAsNumber })}
        />
        <p className="text-xs text-muted-foreground">
          {validTrialDays(days)
            ? `Ends on ${formatTrialDate(trialEndDate(days))}`
            : `Enter 1 to ${MAX_TRIAL_DAYS} days`}
        </p>
      </div>
    )}
  </div>
);

export default TrialLengthFields;
